module.exports = __webpack_public_path__ + "img/box_3.4d885297.png";